export default {
  title: 'list invoices',
  search: 'search ...',
  id: 'id',
  studentName: 'student',
  studentMobile: 'mobile',
  subtotal: 'subtotal',
  totalDiscount: 'total discount',
  totalPrice: 'total price',
  shippingMethod: 'shipping method',
  paymentMethod: 'payment method',
  orderId: 'order id',
  loading: 'loading ... ',
  operating: 'operating',
  empty: 'list is empty',
  next: 'Next',
  previous: 'Previous',
  success: 'success',
}
